module.exports = {
  "zones": {
    "Asia/Colombo": ["z", {
      "wallclock": 1145061000000,
      "format": "+0530",
      "abbrev": "+0530",
      "offset": 19800000,
      "posix": 1145039400000,
      "save": 0
    }, {
      "wallclock": 846289800000,
      "format": "+06",
      "abbrev": "+06",
      "offset": 21600000,
      "posix": 846266400000,
      "save": 0
    }, {
      "wallclock": 832982400000,
      "format": "+0630",
      "abbrev": "+0630",
      "offset": 23400000,
      "posix": 832962600000,
      "save": 0
    }, {
      "wallclock": -764028000000,
      "format": "+0530",
      "abbrev": "+0530",
      "offset": 19800000,
      "posix": -764051400000,
      "save": 0
    }, {
      "wallclock": -862617600000,
      "format": "+0630",
      "abbrev": "+0630",
      "offset": 19800000,
      "posix": -862639200000,
      "save": 3600000
    }, {
      "wallclock": -883267200000,
      "format": "+06",
      "abbrev": "+06",
      "offset": 19800000,
      "posix": -883287000000,
      "save": 1800000
    }, {
      "wallclock": -2019686400000,
      "format": "+0530",
      "abbrev": "+0530",
      "offset": 19800000,
      "posix": -2019705572000,
      "save": 0
    }, {
      "wallclock": -2840140800000,
      "format": "MMT",
      "abbrev": "MMT",
      "offset": 19172000,
      "posix": -2840159964000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": 19164000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {}
};